import {
  v2_useAuthorizedCustomer,
  v2_useProductTaxons,
} from '@crocodille/common';
import NavList from '@components/nav-list/nav-list';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { analyticsEvent } from 'src/modules/analytics';

import * as routing from '../../routing';
import MainNavigationAccount from './main-navigation-account';

const MainNavigation: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();

  const alternativeLocales = useMemo(
    () => (router.locales ?? []).filter((locale) => locale !== router.locale),
    [router.locales, router.locale],
  );

  const { data: customer } = v2_useAuthorizedCustomer();

  const { data: taxons } = v2_useProductTaxons(undefined, 'gift_cards');

  const customerId = customer?.id;

  return (
    <NavList>
      <NavList.Item>
        <Link href={routing.menu()} prefetch={false}>
          {t(`menu_page.title`)}
        </Link>
      </NavList.Item>
      {(taxons ?? []).map((taxon) => (
        <NavList.Item key={`taxon-${taxon.id}`}>
          <Link href={routing.products({ taxon: taxon.slug })}>
            {taxon.name}
          </Link>
        </NavList.Item>
      ))}
      <MainNavigationAccount />
      {alternativeLocales.map((locale) => (
        <NavList.Item key={locale}>
          <Link
            href={router.asPath}
            prefetch={false}
            locale={locale}
            onClick={() => {
              if (customerId) {
                analyticsEvent('user_info', {
                  lang: locale === 'cs' ? 'cs_CZ' : 'en_US',
                  userId: customerId.toString(),
                  userType: 'signed_in',
                });
              } else {
                analyticsEvent('user_info', {
                  lang: locale === 'cs' ? 'cs_CZ' : 'en_US',
                  userType: 'anonymous',
                });
              }
            }}
          >
            {t(`locale_label_${locale}`)}
          </Link>
        </NavList.Item>
      ))}
    </NavList>
  );
};

export default MainNavigation;
